export default __webpack_public_path__ + "static/media/facebook-fill.c7fb395a.svg";